// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import TableComponent from '../../../../atoms/TableComponent/DataTable';
// import axiosInstance from '../../../../lib/axios';
// import { usePermissions } from '../../../../GlobalFunction/userPermissions';
// import { Box, Button, Tooltip } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import { toast } from 'react-toastify';

// const columns = [
//     { id: 'RowNum', label: 'S.No.', minWidth: 170 },
//     { id: 'HkWrkStnName', label: 'Work Station', minWidth: 100 },
//     { id: 'HkWrkAreaName', label: 'Work Area', minWidth: 100 },
//     { id: 'Abrv', label: 'Abbrivation', minWidth: 100 },
//     { id: 'Remark', label: 'Remark', minWidth: 100 },
//     { id: 'Status', label: 'Status', minWidth: 100 }
// ];

// const WorkAreaTable = () => {
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(15);
//     const [searchTerms, setSearchTerms] = useState({});
//     const [rows, setRows] = useState([]);
//     const navigate = useNavigate();

//     useEffect(() => {
//         fetchClassData();
//     }, []);

//     const permissions = usePermissions("Work Area/Cost Center");

//     const { AddRec = "0" } = permissions || {};

//     const handlePermittedClick = () => {
//         if (AddRec === "1") {
//             handleClick();
//         }
//     };

//     const fetchClassData = async () => {
//         try {
//             const response = await axiosInstance.post(
//                 'MstHkWrkArea/getMstHkWrkAreaDashBoard',
//                 {
//                     start: 1,
//                     PageSize: 1,
//                     SearchText: ""
//                 }
//             );

//             if (response.data.Status === 0) {

//                 const formattedData = response.data.Data.map(workArea => ({
//                     ...workArea,
//                     HkWrkStnName: workArea.HkWrkStnName || '',
//                     HkWrkAreaName: workArea.HkWrkAreaName || '',
//                     Abrv: workArea.Abrv || '',
//                     Remark: workArea.Remark || '',
//                     Status: workArea.Status === null ? '' : (workArea.Status == 1 ? 'Active' : 'Inactive')
//                 }));
//                 setRows(formattedData);
//             } else {
//                 toast.info(response.data.Message || 'No record found.');
//             }
//         } catch (error) {
//             toast.error('Error while fetching data:', error);
//         }
//     };

//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(+event.target.value);
//         setPage(0);
//     };

//     const handleClick = () => {
//         navigate('/workarea');
//     };

//     const handleHomeClick = () => {
//         navigate('/dashboard');
//     };

//     const handleSearchChange = (columnId, value) => {
//         setSearchTerms(prev => ({ ...prev, [columnId]: value }));
//         setPage(0);
//     };

//     const filteredRows = React.useMemo(() => {
//         return rows.filter(row => {
//             return Object.entries(searchTerms).every(([columnId, term]) => {
//                 if (!term) return true;
//                 const value = row[columnId];
//                 if (typeof value === 'string') {
//                     return value.toLowerCase().includes(term.toLowerCase());
//                 } else if (typeof value === 'number') {
//                     return value.toString().includes(term);
//                 }
//                 return true;
//             });
//         });
//     }, [searchTerms, rows]);

//     const handleRowDoubleClick = (row) => {
//         navigate('/workarea', { state: { HkWrkAreaId: row.HkWrkAreaId, mode: 'view' } });
//     };

//     const handleLocationclick = () => {
//         navigate('/masters/operations')
//     }

//     const addButtonStyles = {
//         background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
//         color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
//         borderRadius: "50px",
//         padding: "8px 20px",
//         boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
//         transition: "background 0.3s ease",
//         "&:hover": {
//             background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
//         },
//         "&:disabled": {
//             backgroundColor: "rgba(0, 0, 0, 0.12)",
//             color: "rgba(0, 0, 0, 0.26)"
//         }
//     };

//     const Filters = (
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Tooltip
//                 title={AddRec !== "1" ? "You have no permission to add record" : "Add New Record"}
//                 placement="top"
//                 arrow
//             >
//                 <span>
//                     <Button
//                         variant="contained"
//                         onClick={handlePermittedClick}
//                         size="small"
//                         disabled={AddRec !== "1"}
//                         sx={addButtonStyles}
//                     >
//                         <AddIcon /> New
//                     </Button>
//                 </span>
//             </Tooltip>
//         </Box>
//     );

//     return (
//         <TableComponent
//             columns={columns}
//             rows={rows}
//             filteredRows={filteredRows}
//             page={page}
//             title="Operations"
//             titleMaster="Work Area/Cost Center"
//             rowsPerPage={rowsPerPage}
//             FiltersJsx={Filters}
//             handleRowDoubleClick={handleRowDoubleClick}
//             handleSearchChange={handleSearchChange}
//             handleChangePage={handleChangePage}
//             handleChangeRowsPerPage={handleChangeRowsPerPage}
//             handleClick={handleClick}
//             handleHomeClick={handleHomeClick}
//             handleLocationclick={handleLocationclick}
//         />
//     );
// }

// export default WorkAreaTable;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { Box, Chip } from '@mui/material';
import FilterTable from '../../../../atoms/TableComponent/FilterTable/FilterTable';
import axiosInstance from '../../../../lib/axios';
import { toast } from 'react-toastify';

export default function WorkAreaTable() {
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const permissions = usePermissions("Work Area/Sub Station");
    const { AddRec = "0" } = permissions || {};

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post(
                'MstHkWrkArea/getMstHkWrkAreaDashBoard',
                {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                }
            );

            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(workArea => ({
                    ...workArea,
                    HkWrkStnName: workArea.HkWrkStnName || '',
                    HkWrkAreaName: workArea.HkWrkAreaName || '',
                    Abrv: workArea.Abrv || '',
                    Remark: workArea.Remark || '',
                    Status: workArea.Status === null ? '' : (workArea.Status == "1" ? 'Active' : 'Inactive')
                }));
                setRows(formattedData);
            } else {
                setRows([]);
            }
        } catch (error) {
            toast.error('Error while fetching data:', error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handlePermittedClick = () => {
        if (AddRec === "1") {
            handleClick();
        }
    };

    const handleClick = () => {
        navigate('/workarea', { state: { mode: "add" } });
    };

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleLocationclick = () => {
        navigate('/masters/operations');
    };

    const handleRowDoubleClick = (params) => {
        const hkWrkAreaId = params?.data?.HkWrkAreaId;
        if (hkWrkAreaId) {
            navigate('/workarea', { state: { HkWrkAreaId: hkWrkAreaId, mode: 'view' } });
        }
    };

    const TruncatedCellRenderer = (props) => {
        const [isOverflowed, setIsOverflowed] = useState(false);
        const cellRef = React.useRef(null);

        useEffect(() => {
            if (cellRef.current) {
                const isTextOverflowed =
                    cellRef.current.scrollWidth > cellRef.current.clientWidth ||
                    (props.value && props.value.length > 20);
                setIsOverflowed(isTextOverflowed);
            }
        }, [props.value]);

        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        return (
            <div
                ref={cellRef}
                className="truncated-cell"
                style={{ width: '100%' }}
            >
                {cellValue}
            </div>
        );
    };

    const StatusCellRenderer = (props) => {
        const getStatusColor = (status) => {
            switch (status) {
                case 'Active':
                    return '#4caf50';
                case 'Inactive':
                    return '#f44336';
                default:
                    return '#f44336';
            }
        };

        return (
            <Chip
                label={props.value}
                className="status-chip"
                sx={{
                    backgroundColor: getStatusColor(props.value),
                    color: 'white',
                    width: '100%',
                    maxWidth: '100px',
                }}
            />
        );
    };

    const columnDefs = [
        { headerName: 'Sr.No.', field: 'RowNum', width: 60, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        // { headerName: 'Work Station', field: 'HkWrkStnName', minWidth: 200, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Work Area', field: 'HkWrkAreaName', minWidth: 200, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Abbrivation', field: 'Abrv', minWidth: 250, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Remark', field: 'Remark', minWidth: 200, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Status', field: 'Status', width: 100, filter: 'agTextColumnFilter', cellRenderer: StatusCellRenderer },
    ];

    return (
        <Box sx={{ height: '90vh' }}>
            <FilterTable
                columnDefs={columnDefs}
                rowData={rows}
                onRowDoubleClicked={handleRowDoubleClick}
                isLoading={isLoading}
                onHomeClick={handleHomeClick}
                onParentClick={handleLocationclick}
                breadcrumbParentLabel="Operations"
                breadcrumbCurrentLabel="Work Area/Sub Station"
                onAddClick={handlePermittedClick}
                hasAddPermission={AddRec === "1"}
            />
        </Box>
    );
}
